import cn from 'classnames';
import React from 'react';

import cardStyles from '@dealroadshow/uikit/core/styles/card.scss';
import styles from './instructions.scss';

import { instructionsCollection } from './constants';

const instructionCardContent = (instruction) => (
  <div
    key={ instruction.key }
    className={ styles.card }
  >
    <div className={ styles.cardTextWrp }>
      <div className={ styles.cardText }>
        <div className={ styles.cardNumber }>{ instruction.key }</div>
        <h2 className={ styles.cardTitle }>{ instruction.title }</h2>
        <div className={ styles.cardDescription }>{ instruction.description }</div>
      </div>
    </div>
    <div className={ styles.cardImage }>
      <img src={ instruction.image } width={ 362 } height={ 274 } />
    </div>
    <div className={ styles.clear } />
  </div>
);

const Instructions = () => (
  <div className={ cn(cardStyles.cardContainer, styles.instructionsContent) }>
    { instructionsCollection.map(instructionCardContent) }
  </div>
);

export default Instructions;
